// Webpack entry point for module federation.
import("./patterns.js");